import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../components/ui/card';
import { Badge } from '../components/ui/badge';
import { Calendar, Clock, ArrowRight } from 'lucide-react';
import { blogPosts } from '../data/blogData';
import AnimatedCard from '../components/AnimatedCard';
import FadeIn from '../components/FadeIn';

const BlogPage = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-white dark:bg-black text-black dark:text-white py-20 px-6">
      <div className="max-w-6xl mx-auto">
        <FadeIn direction="down">
          <div className="mb-16">
            <h1 className="text-5xl md:text-6xl font-light mb-6 tracking-tight">Blog</h1>
            <p className="text-xl text-gray-600 dark:text-gray-400">
              Exploring AI, data science, and the tools that shape how we build and analyze
            </p>
          </div>
        </FadeIn>

        <div className="space-y-12">
          {blogPosts.map((post, index) => (
            <AnimatedCard key={post.id} delay={index * 0.1}>
              <Card 
              key={post.id} 
              className="group overflow-hidden border border-gray-200 dark:border-gray-800 hover:border-gray-400 dark:hover:border-gray-600 transition-all duration-300 cursor-pointer"
              onClick={() => navigate(`/blog/${post.slug}`)}
            >
              <div className="grid md:grid-cols-3 gap-0">
                <div className="relative h-64 md:h-auto overflow-hidden bg-gray-100 dark:bg-gray-900">
                  <img 
                    src={post.image} 
                    alt={post.title}
                    className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                  />
                </div>
                <div className="md:col-span-2">
                  <CardHeader>
                    <div className="flex items-center gap-3 mb-3 text-sm text-gray-500">
                      <div className="flex items-center gap-1">
                        <Calendar size={16} />
                        <span>{post.date}</span>
                      </div>
                      <div className="flex items-center gap-1">
                        <Clock size={16} />
                        <span>{post.readTime}</span>
                      </div>
                      <Badge variant="outline" className="text-xs">{post.category}</Badge>
                    </div>
                    <CardTitle className="text-2xl font-normal mb-3 leading-tight group-hover:text-gray-600 dark:group-hover:text-gray-400 transition-colors">
                      {post.title}
                    </CardTitle>
                    <CardDescription className="text-base">
                      {post.excerpt}
                    </CardDescription>
                  </CardHeader>
                  <CardContent>
                    <div className="flex items-center gap-2 text-sm font-medium group-hover:gap-3 transition-all">
                      Read full article
                      <ArrowRight size={16} className="group-hover:translate-x-1 transition-transform" />
                    </div>
                  </CardContent>
                </div>
              </div>
            </Card>
            </AnimatedCard>
          ))}
        </div>
      </div>
    </div>
  );
};

export default BlogPage;